//@ts-strict-ignore
import { useBackgroundMutation } from '../../utils/BackgroundJobs';
import SmtpLogResendEmailsMutation from 'graphql/mutations/system/SmtpLogResendEmailsMutation.graphql';
import { useActionVariables } from '../../utils/useActionProps';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import React, { useContext } from 'react';
import { IWorkspaceAction } from '../../@types/workspaceTypes';
import { AlertType, ISmtpLogResendEmailsInput, ISmtpLogResendEmailsPayload } from '../../graphql/schema/p4types';
import { serviceActions } from '../../state/modules/service';
import { useDispatch } from 'react-redux';
import WorkspaceContext from '../../components/Context/WorkspaceContext';

export enum SmtpLogAction {
  Resend = 'SMTP_LOG_RESEND',
}

export const SmtpLogWorkspaceActions = (props) => {
  const { selectionState } = useContext(WorkspaceContext);

  const dispatch = useDispatch();
  const variables = useActionVariables('smtpLogs');
  const [resendEmails] = useBackgroundMutation<ISmtpLogResendEmailsPayload, { input: ISmtpLogResendEmailsInput }>(
    SmtpLogResendEmailsMutation,
    {
      variables: variables,
      jobTitle: 'Resend Emails',
      onCompleteJob: () =>
        dispatch(serviceActions.genericAlert('Resend Emails', 'Emails queued to send', AlertType.Success)),
    }
  );

  const resendAction: IWorkspaceAction<SmtpLogAction> = {
    actionReference: SmtpLogAction.Resend,
    key: 'resendEmails',
    text: 'Resend Emails',
    onClick: () => {
      if (selectionState.actionEntities.length > 0) {
        resendEmails();
        return;
      }
      dispatch(
        serviceActions.genericAlert(
          'Resent Emails',
          'Please use checkboxes to indicate which emails should be resent',
          AlertType.Warning
        )
      );
    },
  };

  return <WorkspaceActionButtons {...props} actionButtons={[resendAction]} />;
};

export const workspace: Array<IWorkspaceAction<SmtpLogAction>> = [
  {
    description: 'Resend Emails',
    actionReference: SmtpLogAction.Resend,
  },
];
